/** Dispatched on the same tab when login/logout updates the JWT in localStorage. */
export const AUTH_TOKEN_CHANGED_EVENT = 'ci-auth-token-changed';

export const notifyAuthTokenChanged = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_TOKEN_CHANGED_EVENT));
  }
};
